var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-tooltip',_vm._b({attrs:{"header":_vm.$t('creator.samplesStep'),"title":_vm.$t('creator.samplesTipTitle'),"text":_vm.$t('creator.samplesTipText'),"icon":"ImageIcon"}},'rich-tooltip',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }